import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '../../assets/arrow-right.png';
const _hoisted_1 = ["onClick"];
const _hoisted_2 = ["src"];
import { useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArticleList',
    props: {
        articles: {},
        bottomrighticon: {}
    },
    setup(__props) {
        const router = useRouter();
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_chip = _resolveComponent("v-chip");
            return (_openBlock(), _createElementBlock("div", {
                class: "article-list",
                style: _normalizeStyle('background-image:url(' + _ctx.bottomrighticon + ')'),
                onClick: _cache[0] || (_cache[0] = event => { event.stopPropagation(); })
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: article.id,
                        class: "article-wrapper",
                        onClick: ($event) => (_unref(router).push('/articles/' + article.id))
                    }, [
                        _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "v-col-9 title-col" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(article.title), 1)
                                    ]),
                                    _: 2
                                }, 1024),
                                _createVNode(_component_v_col, { class: "v-col-3 thumb-col" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("img", {
                                            src: article.iconImage
                                        }, null, 8, _hoisted_2)
                                    ]),
                                    _: 2
                                }, 1024)
                            ]),
                            _: 2
                        }, 1024),
                        _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "description-col" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(article.shortSummary), 1)
                                    ]),
                                    _: 2
                                }, 1024)
                            ]),
                            _: 2
                        }, 1024),
                        _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "v-col-9 tags-col" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_chip, {
                                            class: "articleTag",
                                            variant: "outlined",
                                            size: "x-small"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(article.tagsArray[0]), 1)
                                            ]),
                                            _: 2
                                        }, 1024)
                                    ]),
                                    _: 2
                                }, 1024),
                                _createVNode(_component_v_col, { class: "" }),
                                _createVNode(_component_v_col, { class: "arrow-col" }, {
                                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                                        _createElementVNode("img", {
                                            class: "arrow",
                                            src: _imports_0
                                        }, null, -1)
                                    ])),
                                    _: 1
                                })
                            ]),
                            _: 2
                        }, 1024)
                    ], 8, _hoisted_1));
                }), 128))
            ], 4));
        };
    }
});
